import { render, staticRenderFns } from "./AssetApprovals.vue?vue&type=template&id=39978fb5"
import script from "./AssetApprovals.vue?vue&type=script&lang=js"
export * from "./AssetApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports